// IMPORTANT: This file should contain no imports.

type Location = {
  key: string;
  path: string;
};

export const STACK_KEY = '__history';

export function getLocationKey() {
  let [key] = parseState(history.state);
  return key;
}

export function getLocation(): Location {
  let [key] = parseState(history.state);
  return {
    key,
    path: location.pathname + location.search,
  };
}

export function getHistoryStack(): Array<Location> {
  let state = toStateObject(history.state);
  let stack = state[STACK_KEY];
  return Array.isArray(stack) ? stack.filter((loc) => isLocation(loc)) : [];
}

export function parseState(state: unknown) {
  let { key: maybeKey, ...otherState } = toStateObject(state);
  let key = typeof maybeKey === 'string' ? maybeKey : '';
  return [key, otherState] as const;
}

function toStateObject(input: unknown) {
  return isObject(input) ? input : {};
}

export function findInHistory(path: string) {
  let stack = getHistoryStack();
  let index = findLastIndex(stack, (location) => location.path === path);
  if (index !== -1) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let location = stack[index]!;
    let delta = index - stack.length;
    return { location, index, delta };
  }
}

function isLocation(input: unknown): input is Location {
  return (
    isObject(input) &&
    typeof input.key === 'string' &&
    typeof input.path === 'string'
  );
}

function isObject(input: unknown): input is Record<string, unknown> {
  return Object(input) === input;
}

function findLastIndex<T>(
  array: Array<T>,
  match: (item: T) => boolean,
): number {
  for (let i = array.length - 1; i >= 0; i--) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let item = array[i]!;
    if (match(item)) {
      return i;
    }
  }
  return -1;
}
